/**
 * Contact validation — mirrors public.normalize_in_mobile / normalize_in_phone in the database.
 * Numbers are stored as +91XXXXXXXXXX; accepted input: optional +91 / 91 / 0 prefix,
 * spaces, dashes, brackets.
 */

function digitsOnly(input: string): string {
  let d = input.replace(/[\s\-().]/g, '');
  d = d.replace(/^(\+91|0091)/, '');
  if (d.length === 12 && d.startsWith('91')) d = d.slice(2);
  if (d.length === 11 && d.startsWith('0')) d = d.slice(1);
  return d;
}

/** Indian mobile (10 digits starting 6–9) → "+91XXXXXXXXXX", or null if invalid/empty. */
export function normalizeIndianMobile(input: string | null | undefined): string | null {
  if (!input?.trim()) return null;
  const d = digitsOnly(input.trim());
  return /^[6-9]\d{9}$/.test(d) ? `+91${d}` : null;
}

/** Indian phone — mobile or landline with STD code (10 digits, not starting 0). */
export function normalizeIndianPhone(input: string | null | undefined): string | null {
  if (!input?.trim()) return null;
  const d = digitsOnly(input.trim());
  return /^[1-9]\d{9}$/.test(d) ? `+91${d}` : null;
}

export const MOBILE_ERROR = 'Enter a valid Indian mobile number — 10 digits starting with 6, 7, 8 or 9 (e.g. 98765 43210).';
export const PHONE_ERROR = 'Enter a valid Indian phone number — 10-digit mobile, or landline with STD code (e.g. 022 2345 6789).';
export const EMAIL_ERROR = 'Enter a valid email address.';

export function isValidEmail(input: string | null | undefined): boolean {
  return !!input && /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(input.trim());
}

/** "+919876543210" → "+91 98765 43210". Unrecognised text is returned unchanged. */
export function formatPhone(value: string | null | undefined): string {
  if (!value) return '';
  const m = /^\+91(\d{10})$/.exec(value.replace(/\s/g, ''));
  return m ? `+91 ${m[1].slice(0, 5)} ${m[1].slice(5)}` : value;
}

/** tel: link target for a stored number. */
export function telHref(value: string | null | undefined): string | undefined {
  if (!value) return undefined;
  const digits = value.replace(/[^\d+]/g, '');
  return digits ? `tel:${digits}` : undefined;
}
